import { useState } from "react";

/**
 * The small round "i" that explains a figure, modelled on the one beside the neighborhood
 * name in Property Details.
 *
 * Opens on hover AND on click: the client share page is read on a phone more often than a
 * desktop, and a hover-only tooltip is invisible to a touch screen. The bubble is anchored to
 * the dot's right edge and grows leftwards, because these sit at the right-hand end of a
 * space-between row where a centred bubble would hang off the card.
 */
export default function InfoDot({ text, label = "What is this?" }) {
  const [open, setOpen] = useState(false);

  return (
    <span
      style={{ marginLeft: "6px", display: "inline-block", position: "relative" }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <span
        role="button"
        tabIndex={0}
        aria-label={label}
        onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setOpen((o) => !o); }
        }}
        style={{
          display: "inline-block", width: "16px", height: "16px", borderRadius: "50%",
          backgroundColor: "#1976d2", color: "#fff", fontSize: "12px", fontWeight: "bold",
          textAlign: "center", lineHeight: "16px", cursor: "help", userSelect: "none",
        }}
      >i</span>
      {open && (
        <div
          style={{
            position: "absolute", top: "22px", right: 0,
            backgroundColor: "#333", color: "#fff", padding: "10px 12px", borderRadius: "6px",
            fontSize: "12px", lineHeight: 1.5, fontWeight: 400, textAlign: "left",
            // Wide enough for a sentence, never wider than the phone it is read on.
            width: "max-content", maxWidth: "min(280px, 75vw)", whiteSpace: "normal",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)", zIndex: 1000,
          }}
        >
          {text}
        </div>
      )}
    </span>
  );
}
